import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '@hm/environments/environment';

import { AppointmentSuggestionResponse, PlanPrescriptionPayload, UpdatePrescriptionPlanningPayload } from '@lib/core/models/create-appointment.interface';

@Injectable({
  providedIn: 'root',
})
export class CreateAppointmentService {
  private http = inject(HttpClient);

  createAppointment(payload: PlanPrescriptionPayload) {
    return this.http.post(`${environment.healthManagerApiUrl}/prescriptions/plannings`, payload);
  }

  cancelAppointment(prescriptionId: string, planningId: string) {
    return this.http.post(`${environment.healthManagerApiUrl}/prescriptions/${prescriptionId}/plannings/${planningId}/cancel`, {});
  }

  updateAppointment(prescriptionId: string, planningId: string, payload: UpdatePrescriptionPlanningPayload) {
    return this.http.post(`${environment.healthManagerApiUrl}/prescriptions/${prescriptionId}/plannings/${planningId}/update`, payload);
  }

  getAppointmentSuggestions(userId: string, partnerId: string) {
    const options = {
      params: new HttpParams().set('userId', userId).set('partnerId', partnerId),
    };

    return this.http.get<AppointmentSuggestionResponse[]>(`${environment.healthManagerApiUrl}/appointments/suggestions`, options);
  }
}
